"use client";

import { useSyncExternalStore } from "react";

/**
 * Ürün kartlarında hover ile gezilen çoklu görsel galerisi açılabilir mi?
 *
 * true  → desktop: kartta tüm görseller, hover ile resim değiştirme
 * false → mobil/dokunmatik: kartta sadece ana görsel (images[0])
 *
 * İki koşul birden aranıyor:
 * - `(hover: hover) and (pointer: fine)` — gerçek imleç. Genişlik tek başına
 *   yetmez: 1024px+ tabletler genişlikçe desktop sayılır ama dokunmatiktir,
 *   orada hover hiç çalışmaz.
 * - `(min-width: 768px)` — daraltılmış masaüstü penceresi de mobil davransın.
 *   ProductCardHoverActions zaten `hidden md:block`; galeri aynı eşiği izler.
 *
 * SSR'da false döner (mobil varsayılan). Desktop'ta hydration sonrası true'ya
 * geçer; ek görseller opacity:0 katmanı olduğu için görünür değişiklik/CLS yok.
 */

const QUERY = "(hover: hover) and (pointer: fine) and (min-width: 768px)";

// Modül seviyesinde tek MediaQueryList — kaç bileşen abone olursa olsun
// tarayıcı tarafında tek sorgu tutulur.
let mql: MediaQueryList | null = null;

const getMql = (): MediaQueryList | null => {
  if (typeof window === "undefined") return null;
  if (!mql) mql = window.matchMedia(QUERY);
  return mql;
};

const subscribe = (onStoreChange: () => void) => {
  const m = getMql();
  if (!m) return () => {};
  m.addEventListener("change", onStoreChange);
  return () => m.removeEventListener("change", onStoreChange);
};

// Primitive döner — useSyncExternalStore referans karşılaştırması güvenli.
const getSnapshot = () => getMql()?.matches ?? false;
const getServerSnapshot = () => false;

export const useHoverGallery = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
